import ImageContainer from "@components/imageContainer";
import { resolvePath } from "@utils/resolvePath";
import { Flex, styled } from "@acko-tech/building-blocks.ui.common";
import { setInstrumentationData, setPayloadData } from "@store/slices/globalState";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { executeActions } from "@utils/index";

const Container = styled.div`
  width: 100%;
`;

const CardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 12px;
  border: 1px solid var(--line-primary-n-200, #e7e7f0);
  padding: 16px;
  margin-bottom: 16px;
  ${(props) =>
    props.selected &&
    `
  border-radius: 12px;
  border: 1px solid var(--button-default-g-300, #0FA457);
  background: rgba(15, 164, 87, 0.05);
  `}
`;

const CardContent = styled.div`
  flex: 1;
  padding-right: 16px;
`;

const CardTitle = styled.div`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  padding-bottom: 4px;
`;

const CardDescription = styled.div`
  color: var(--text-secondary-n-400, #5b5675);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const ImageWrapper = styled.div`
  height: 75px;
  width: 75px;
`;

const SeeMore = styled.div`

`;

const SeeMoreButton = styled.button`
  color: var(--button-hyperlink-b-300, #1B73E8);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  border: none;
  background-color: #fff;
`;

const DealershipDetailsAndSelection = (props: any) => {
  const {
    dealership_list,
    dealership_details,
    selected_dealership,
    selected_dealership_id,
    dealershipData,
    actions
  } = props;
  const { on_click } = actions || {};
  const dispatch = useDispatch();
  const [isOpened, setIsOpened] = useState(false)
  const [dealerships, setDealerships] = useState(dealership_list)
  useEffect(() => {
    dispatch(
      setPayloadData({
        dealership_name: selected_dealership?.replace("Acko Trusted", ""),
        dealership_id: selected_dealership_id
      })

    );

    // if any dealership is preselected, enable CTA
    if (dealerships?.length) {
      let ifPreselected = -1
      dealerships?.forEach((item, index) => {
        if (dealershipData?.dealership_name === item?.name?.replace("Acko Trusted", "") || dealershipData?.dealership_id === item?.id) {
          ifPreselected = index
          executeActions(on_click || [])
        }
      })

      if (ifPreselected !== -1) {
        let tempDealerships = [...dealerships]
        tempDealerships.unshift(tempDealerships.splice(ifPreselected, 1)[0]);
        setDealerships(tempDealerships)
        // TODO: find a better way to implement this
        setTimeout(() => executeActions(on_click || []), 10)
      }
    }
  }, []);

  const { payloadData } = useSelector(({ globalState }: any) => {
    return {
      payloadData: globalState?.payloadData,
      instrumentationData: globalState?.instrumentationData
    };
  });

  return (
    <Container>
      {dealerships?.length > 0 &&
        dealerships?.map((item, index) => (
          <>
            {index < 3 || isOpened ? <Card
              key={item?.id}
              dealership={item}
              selected={
                payloadData?.dealership_name === item?.name?.replace("Acko Trusted", "") ||
                payloadData?.dealership_id === item?.id
              }
              on_click={on_click}
            /> : null
            }

          </>
        ))}
      <></>
      {
        !isOpened && dealerships && dealerships.length > 3 ?
          <Flex alignItems="center" justifyContent="center" width="100%" margin="16px 0 16px 0">
            <div>
              <SeeMoreButton onClick={() => setIsOpened(!isOpened)}>
                <>
                  <span style={{ marginRight: "4px" }}>View more</span>{" "}
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                    <path d="M10.9662 1.05554C11.2092 0.813985 11.209 0.420854 10.9659 0.179473C10.725 -0.059771 10.3361 -0.0596089 10.0953 0.179835L5.5777 4.67318L1.05181 0.179137C0.810999 -0.0599791 0.422363 -0.059979 0.181553 0.179137C-0.061675 0.420653 -0.0616749 0.814046 0.181553 1.05556L4.8726 5.71359C5.26274 6.10099 5.89244 6.10077 6.28231 5.71309L10.9662 1.05554Z" fill="#1B73E8" />
                  </svg>
                </>
              </SeeMoreButton>
            </div>
          </Flex> : null
      }
    </Container>
  );
};

const Card = (props: any) => {
  const dispatch = useDispatch();
  const { dealership, selected, on_click } = props;
  const {
    name,
    id,
    metadata: { address, display_name }
  } = dealership;

  const handleDealershipClick = (dealership: any) => {
    dispatch(
      setPayloadData({
        dealership_name: display_name?.replace("Acko Trusted", "") || name?.replace("Acko Trusted", ""),
        dealership_id: id
      })
    );
    dispatch(
      setInstrumentationData({
        dealership_name: display_name?.replace("Acko Trusted", "") || name?.replace("Acko Trusted", ""),
        dealership_id: id
      })
    );
    executeActions(on_click || []);
  };

  return (
    <CardWrapper selected={selected}>
      <CardContent onClick={() => handleDealershipClick(dealership)}>
        <CardTitle>{display_name?.replace("Acko Trusted", "") || name?.replace("Acko Trusted", "")}</CardTitle>
        <CardDescription>{address}</CardDescription>
      </CardContent>
      {/* <ImageWrapper>
        <ImageContainer
          imgSrc={resolvePath("/images/sampleDealership.svg")}
          alt="carIcons"
          width={75}
          height={75}
        />
      </ImageWrapper> */}
    </CardWrapper>
  );
};

export default DealershipDetailsAndSelection;
